import React from 'react'
import NoData from './NoData'

function DocumentImage({imageUrl, title="", width="300", height="240"}) {
  return imageUrl ? (
    <a target='_blank' href={imageUrl}><div className='doc-container doc-image'>
        <img className="" src={imageUrl} width={width} height={height} alt={title}/>
        <div class="doc-overlay">
            <div class="doc-text">{title}</div>
        </div>
        </div>
    </a>
  ) : (<div className='doc-container doc-image'>
        {/* <img className="" src={imageUrl} width={width} height={height} alt={title}/> */}
        <NoData title='No Image Found' />
        </div>)
}

export default DocumentImage